export default function EventList() {
  return <div>Event List Page WIP</div>;
}
